__turbopack_context__.v({
  "emergency-number": "EmergencyNumber-module-scss-module__lZgh-G__emergency-number",
});
